export default __webpack_public_path__ + "static/media/FSKoopman-BoldItalic.e8b2dc21.woff";